"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../../../shared");
var DatePickerInput_meta_1 = require("./DatePickerInput.meta");
var InputWrapper_1 = __importDefault(require("../../styledComponents/DatePickerInput/InputWrapper"));
var Input_1 = __importDefault(require("../../styledComponents/DatePickerInput/Input"));
var ButtonToggle_1 = __importDefault(require("../../styledComponents/DatePickerInput/ButtonToggle"));
var ToggleIcon_1 = __importDefault(require("../../styledComponents/DatePickerInput/ToggleIcon"));
var Image_1 = __importDefault(require("../../../Image"));
var Translate_1 = __importDefault(require("../../../Translate"));
var Translate_2 = require("../../../Translate/Translate");
var DatePickerInput = /** @class */ (function (_super) {
    __extends(DatePickerInput, _super);
    function DatePickerInput(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DatePickerInput_meta_1.DATE_PICKER_INPUT_CATEGORY_KEY;
        _this.componentKey = DatePickerInput_meta_1.DATE_PICKER_INPUT_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(DatePickerInput.prototype, "parentComponentKey", {
        get: function () {
            return DatePickerInput_meta_1.DATE_PICKER_INPUT_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    DatePickerInput.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, dateFormatter = _a.dateFormatter, localization = _a.localization, name = _a.name, formattedValue = _a.formattedValue, valueAsDate = _a.valueAsDate, value = _a.value, identifier = _a.identifier, disabled = _a.disabled, required = _a.required, role = _a.role, buttonRef = _a.buttonRef, inputRef = _a.inputRef, onInput = _a.onInput, onBlur = _a.onBlur, onFocus = _a.onFocus;
        return (react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
            return react_1.default.createElement(InputWrapper_1.default, { className: "input-wrapper" },
                react_1.default.createElement(Input_1.default, { key: formattedValue, className: "input", defaultValue: formattedValue, placeholder: translationContext.translate(localization.placeholder), id: identifier, disabled: disabled, role: role, required: required ? true : undefined, "aria-autocomplete": "none", onInput: onInput, onFocus: onFocus, onBlur: onBlur, autoComplete: "off", innerRef: inputRef }),
                react_1.default.createElement("input", { type: "hidden", name: name, value: value }),
                react_1.default.createElement(ButtonToggle_1.default, { className: "toggle", onClick: onClick, disabled: disabled, innerRef: buttonRef, type: "button" },
                    react_1.default.createElement(ToggleIcon_1.default, { className: "toggle-icon" },
                        react_1.default.createElement(Image_1.default, { "aria-hidden": true, asset: "base.datePicker.calendar" })),
                    react_1.default.createElement("span", { className: "vhidden" },
                        react_1.default.createElement(Translate_1.default, null, localization.buttonLabel),
                        valueAsDate && (react_1.default.createElement("span", null,
                            ", ",
                            react_1.default.createElement(Translate_1.default, null, localization.selectedDateMessage),
                            " ",
                            dateFormatter.format(valueAsDate))))));
        }));
    };
    DatePickerInput = __decorate([
        mobx_react_1.observer
    ], DatePickerInput);
    return DatePickerInput;
}(shared_1.ComponentBase));
exports.DatePickerInput = DatePickerInput;
exports.default = shared_1.InjectedStyledComponent(DatePickerInput, DatePickerInput_meta_1.DATE_PICKER_INPUT_CATEGORY_KEY, DatePickerInput_meta_1.DATE_PICKER_INPUT_PARENT_COMPONENT_KEY, [DatePickerInput_meta_1.DATE_PICKER_INPUT_COMPONENT_KEY]);
